import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              세금의 <span className="highlight">결</span>을 압니다
            </h1>
            <h2 className="hero-subtitle">세무회계 결</h2>
            <p className="hero-description">
              <span className="desktop-text">세무회계 결은 고품격 세무 서비스를 제공하기 위해 모인 최고의 전문가 그룹으로,<br />당신의 완벽한 재무 파트너가 되어 드릴 것을 약속합니다.</span>
              <span className="mobile-text">세무회계 결은 고품격 세무 서비스를 제공하기 위해<br />당신의 완벽한 재무 파트너가 되어 드릴 것을 약속합니다.</span>
            </p>
            <div className="hero-buttons desktop-only">
              <Link to="/contact" className="btn btn-primary">상담 문의</Link>
              <Link to="/services" className="btn btn-secondary">업무 안내</Link>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-text">업종별 전문세무사</div>
              <div className="stat-detail">개업·개원·개국 준비부터 책임관리 서비스</div>
            </div>
            <div className="stat-card stat-card-center">
              <div className="stat-text">양도·상속·증여</div>
              <div className="stat-detail">재산세제 전문 컨설팅</div>
            </div>
            <div className="stat-card">
              <div className="stat-text">고객 만족</div>
              <div className="stat-detail">상황별·사업모델별 최적 세금 전략 수립</div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="about-section">
        <div className="container">
          <h2 className="section-title">세무회계 결과 함께하세요</h2>
          <p className="section-description desktop-only">
            고객의 성공적인 사업을 위해 정확하고 신속한 세무 서비스를 제공합니다.<br />
            복잡한 세무 업무, 이제 전문가에게 맡기고 본업에 집중하세요.
          </p>
          <div className="features-grid">
            <div className="feature-card">
              <h3>정확한 처리</h3>
              <p>전문 세무사가 법령에 따라<br />정확하게 업무를 처리합니다</p>
            </div>
            <div className="feature-card">
              <h3>신속한 대응</h3>
              <p>빠르게 대응하여<br />발생가능한 불이익을 최소화 합니다</p>
            </div>
            <div className="feature-card">
              <h3>신뢰할 수 있는 파트너</h3>
              <p>지속적인 관리와 상담으로<br />고객의 든든한 세무 파트너가 되겠습니다</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <div className="cta-image">
              <div className="logo-container">
                <img 
                  src="/images/세무회계 결 ver 2.png" 
                  alt="세무회계 결 로고" 
                  className="cta-logo"
                />
              </div>
            </div>
            <div className="cta-text">
              <h2 className="cta-title">
                <span className="desktop-text">세금이 심플할수록, 우리의 방향도 명확합니다</span>
                <span className="mobile-text">다양한 상황<br />복잡한 유형<br />난해한 세금<br /><br />쉽게 설명드립니다<br /><br />심플한 세금<br />명확한 결이 있습니다</span>
              </h2>
              <p className="cta-description desktop-only">
                맞춤형 세무서비스로 함께 나아가는 길을 열어드립니다.
              </p>
              <p className="cta-subtitle desktop-only">
                세무회계 결과 함께하는 더 나은 내일을 시작하세요.
              </p>
              <Link to="/contact" className="btn btn-contact desktop-only">
                CONTACT <span className="arrow">↗</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="partners">
        <div className="container">
          <h2 className="section-title">관련 기관 및 파트너</h2>
          <p className="section-description">신뢰할 수 있는 공공기관과 함께합니다.</p>
          <div className="partners-carousel">
            <a href="https://www.moef.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.nts.go.kr/favicon.ico" alt="기획재정부" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>기획재정부</span>
            </a>
            <a href="https://www.moef.go.kr/sns/mainIndex.do" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.korea.kr/favicon.ico" alt="한눈에 보는 정책" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>한눈에 보는 정책</span>
            </a>
            <a href="https://www.nts.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.nts.go.kr/favicon.ico" alt="국세청" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>국세청</span>
            </a>
            <a href="https://hometax.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.hometax.go.kr/favicon.ico" alt="국세청 홈택스" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>국세청 홈택스</span>
            </a>
            <a href="https://www.sejungilbo.com/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.taxtimes.co.kr/favicon.ico" alt="세정일보" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>세정일보</span>
            </a>
            <a href="https://www.joseilbo.com/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.joseilbo.com/favicon.ico" alt="조세일보" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>조세일보</span>
            </a>
            <a href="https://www.kacta.or.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.kacpta.or.kr/favicon.ico" alt="한국세무사회" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>한국세무사회</span>
            </a>
            <a href="https://www.moef.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.nts.go.kr/favicon.ico" alt="기획재정부" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>기획재정부</span>
            </a>
            <a href="https://www.moef.go.kr/sns/mainIndex.do" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.korea.kr/favicon.ico" alt="한눈에 보는 정책" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>한눈에 보는 정책</span>
            </a>
            <a href="https://www.nts.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.nts.go.kr/favicon.ico" alt="국세청" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>국세청</span>
            </a>
            <a href="https://hometax.go.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.hometax.go.kr/favicon.ico" alt="국세청 홈택스" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>국세청 홈택스</span>
            </a>
            <a href="https://www.sejungilbo.com/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.taxtimes.co.kr/favicon.ico" alt="세정일보" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>세정일보</span>
            </a>
            <a href="https://www.joseilbo.com/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.joseilbo.com/favicon.ico" alt="조세일보" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>조세일보</span>
            </a>
            <a href="https://www.kacta.or.kr/" target="_blank" rel="noopener noreferrer" className="partner-item">
              <img src="https://www.kacpta.or.kr/favicon.ico" alt="한국세무사회" className="partner-icon" onError={(e) => {e.target.style.display='none'}} />
              <span>한국세무사회</span>
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
